export default __webpack_public_path__ + "static/media/080_finish_good.vp9.b0564f24.webm";